import * as React from 'react'

const Context = React.createContext<{ focusKey?: string }>({ focusKey: undefined })

export default Context



// WEBPACK FOOTER //
// ./src/components/FocusKeyContext/FocusKeyContext.tsx